[
    {
        "name": "global_superadmin",
        "context": false,
        "inherits": [
            "global_beta_tester",
            "global_spotme",
            "global_spotme_finance",
            "global_spotme_csm",
            "global_spotme_am",
            "global_spotme_product",
            "global_spotme_support",
            "global_app_publisher",
            "global_developer",
            "account_admin",
            "account_developer",
            "account_entitlement_manager",
            "event_manager",
            "customer_api_developer"
        ]
    },
    {
        "name": "global_beta_tester",
        "context": false,
        "inherits": ["global_logged"]
    },
    {
        "name": "global_app_publisher",
        "context": false,
        "inherits": ["global_logged"]
    },
    {
        "name": "global_spotme_product",
        "context": false,
        "inherits": ["global_spotme"]
    },
    {
        "name": "global_spotme_csm",
        "context": false,
        "inherits": ["global_spotme"]
    },
    {
        "name": "global_spotme_support",
        "context": false,
        "inherits": ["global_spotme", "event_manager", "account_admin", "account_entitlement_manager"]
    },
    {
        "name": "global_developer",
        "context": false,
        "inherits": []
    },
    {
        "name": "global_spotme_am",
        "context": false,
        "inherits": ["global_spotme"]
    },
    {
        "name": "global_spotme",
        "context": false,
        "inherits": ["global_logged"]
    },
    {
        "name": "global_spotme_finance",
        "context": false,
        "inherits": ["global_spotme"]
    },
    {
        "name": "global_logged",
        "context": false,
        "inherits": []
    },
    {
        "name": "global_logged_granular",
        "context": false,
        "inherits": []
    },
    {
        "name": "global_event_logged_granular",
        "context": false,
        "inherits": ["global_logged_granular"]
    },
    {
        "name": "account_guest",
        "context": ["org_id"],
        "inherits": ["global_logged_granular"]
    },
    {
        "name": "account_member",
        "context": ["org_id"],
        "inherits": ["account_guest", "global_logged"]
    },
    {
        "name": "account_organizer",
        "context": ["org_id"],
        "inherits": ["account_member"]
    },
    {
        "name": "account_admin",
        "context": ["org_id"],
        "inherits": ["account_organizer", "account_developer"]
    },
    {
        "name": "account_developer",
        "context": ["org_id"],
        "inherits": ["account_api_developer"]
    },
    {
        "name": "account_api_developer",
        "context": ["org_id"],
        "inherits": ["account_member"]
    },
    {
        "name": "account_entitlement_manager",
        "context": ["org_id"],
        "inherits": ["account_member"]
    },

    {
        "name": "event_manager",
        "context": ["event_id"],
        "inherits": ["event_editor"]
    },
    {
        "name": "event_editor",
        "context": ["event_id"],
        "inherits": [
            "event_viewer",
            "event_speaker",
            "event_moderator",
            "event_live_display",
            "event_sponsor"
        ]
    },
    {
        "name": "event_viewer",
        "context": ["event_id"],
        "inherits": ["global_logged"]
    },
    {
        "name": "event_speaker",
        "context": ["event_id"],
        "inherits": ["global_logged"]
    },
    {
        "name": "event_moderator",
        "context": ["event_id"],
        "inherits": ["global_logged"]
    },
    {
        "name": "event_live_display",
        "context": ["event_id"],
        "inherits": ["global_logged"]
    },
    {
        "name": "event_sponsor",
        "context": ["event_id"],
        "inherits": ["global_logged"]
    },
    {
        "name": "event_badge_printing_staff",
        "context": ["event_id"],
        "inherits": ["global_event_logged_granular"]
    },
    {
        "name": "event_meeting_planner",
        "context": ["event_id"],
        "inherits": ["global_event_logged_granular"]
    },
    {
        "name": "customer_api_developer",
        "context": ["customer_id"],
        "inherits": ["account_developer"]
    }
]
